<template>
  <div>
    <v-text-field
      v-model="instance.firstName"
      label="Prénom *"
      v-validate=""
      data-vv-name="firstName"
      :error-messages="errors.collect('firstName')"
    ></v-text-field>
    <v-text-field
      v-model="instance.lastName"
      label="Nom de famille *"
      v-validate=""
      data-vv-name="lastName"
      :error-messages="errors.collect('lastName')"
    ></v-text-field>
    <v-text-field
      v-model="instance.phone"
      label="Téléphone *"
      v-validate=""
      data-vv-name="phone"
      :error-messages="errors.collect('phone')"
    ></v-text-field>
    <vuetify-google-autocomplete
      v-model="instance.actualCity"
      data-vv-name="actualCity"
      v-validate=""
      id="map"
      append-icon="map"
      label="Adresse de départ"
      @placechanged="
        data => {
          if (data) instance.actualCityObject = data;
        }
      "
      :error-messages="errors.collect('actualCity')"
    >
    </vuetify-google-autocomplete>
    <v-menu
      ref="menu"
      :close-on-content-click="true"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="cleanWorkDate"
          prepend-icon="event"
          v-on="on"
          label="Date d'emménagement"
          data-vv-name="workDate"
          :error-messages="errors.collect('workDate')"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="instance.dateMove"
        no-title
        scrollable
        :allowed-dates="isInFuture"
      >
        <v-spacer></v-spacer>
      </v-date-picker>
    </v-menu>
    <v-text-field
      v-model="instance.sponsor"
      label="D'où nous connaissez vous ?"
      hint="Réseaux sociaux, parrain, démarchage..."
    />
    <v-select
      v-model="instance.serviceWish"
      :items="serviceWish"
      label="Quel service souhaitez-vous ?"
    />
    <vuetify-google-autocomplete
      v-model="instance.moveWish"
      id="movewish"
      append-icon="map"
      label="Dans quelle ville souhaitez-vous déménager ?"
      @placechanged="placeChanged"
    />
  </div>
</template>

<script>
import moment from "moment";
import { SERVICE_WISH } from "../../../../webapp-commons/data";

export default {
  name: "ProjectBasics",
  props: ["value", "project"],
  computed: {
    cleanWorkDate: function() {
      let v = this.instance.dateMove;
      if (v == null) {
        return v;
      }
      return moment(String(v)).format("DD/MM/YYYY");
    },
    serviceWish() {
      return SERVICE_WISH;
    }
  },
  mounted() {
    this.syncWithProject();
  },
  methods: {
    syncWithProject() {
      if (this.project != null) {
        const {
          dateMove,
          actualCityObject,
          phoneNumber,
          sponsor,
          actualCity,
          firstName,
          lastName,
          serviceWish,
          moveWish
        } = this.project;
        this.instance = {
          actualCity,
          firstName,
          lastName,
          phone: phoneNumber,
          dateMove,
          actualCityObject,
          sponsor,
          serviceWish,
          moveWish
        };
      }
      this.send();
    },
    placeChanged(data, place) {
      if (data && place) {
        this.currentProject.moveWish = place.formatted_address;
      }
    },
    async send() {
      await this.$validator.validate();
      this.$emit("input", { ...this.instance });
    },
    isInFuture(date) {
      return moment(date).isAfter();
    }
  },
  data() {
    return {
      instance: {
        actualCity: "",
        dateMove: null,
        firstName: "",
        lastName: "",
        phone: "",
        actualCityObject: null,
        sponsor: "",
        serviceWish: "",
        moveWish: ""
      }
    };
  },
  watch: {
    instance: {
      deep: true,
      async handler() {
        this.send();
      }
    },
    project: {
      deep: true,
      handler() {
        this.syncWithProject();
      }
    }
  }
};
</script>

<style scoped></style>
